export default __webpack_public_path__ + "static/media/pencilCup.3d3f1557.jpg";